// src/contexts/CompetitionContext.js
import React, { createContext, useState } from 'react';

export const CompetitionContext = createContext(null);

export const CompetitionProvider = ({ children }) => {
    const [competition, setCompetition] = useState(null);

    return (
        <CompetitionContext.Provider value={{ competition, setCompetition }}>
            {children}
        </CompetitionContext.Provider>
    );
};
